import { Heading } from "@root/clientFrontend/components/Heading";
import { Label } from "@root/shared/components/Label";
import { RadioButton } from "@root/shared/components/RadioButton";
import { type ComponentProps, type FC } from "react";
import { InformationText } from "@root/shared/components/InformationText";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type Props = {
  questionTitle: ComponentProps<typeof Heading>["children"];
  titleTag: ComponentProps<typeof Heading>["tag"];
  questions: {
    text: string;
    radioButtonProps: Omit<ComponentProps<typeof RadioButton>, "name">;
  }[];
  name: string;
};

export const HeadingAndRadioButtons: FC<Props> = ({
  questionTitle,
  titleTag = "p",
  questions,
  name,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name];
  return (
    <>
      <Heading tag={titleTag} size="small" label={<Label theme="red">必須</Label>}>
        {questionTitle}
      </Heading>
      {error && (
        <div className={styles.errorTextOuter}>
          <InformationText text={error.message} isAlert />
        </div>
      )}
      <div className={styles.questions}>
        {questions.map(({ text, radioButtonProps }) => {
          const id = `radiobutton-${name}-${radioButtonProps.value}`;
          return (
            <label key={text} htmlFor={id} className={styles.label}>
              <RadioButton {...radioButtonProps} id={id} {...register(name)} hasError={!!error} />
              <span className={styles.questionText}>{text}</span>
            </label>
          );
        })}
      </div>
    </>
  );
};
